const analyticsLoggingEnabled =
  typeof window !== "undefined" &&
  localStorage.getItem("analytics-logging-enabled");

export const analyticsLogger =
  analyticsLoggingEnabled === "true"
    ? console
    : { log: () => {}, warn: () => {}, error: () => {}, info: () => {} };

const standardLoggingEnabled =
  typeof window !== "undefined" && localStorage.getItem("logging-enabled");

export const clientLogger =
  standardLoggingEnabled === "true"
    ? console
    : { log: () => {}, warn: () => {}, error: () => {}, info: () => {} };
